import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {CardOnline} from "../models/cardOnline";

@Injectable({ providedIn: 'root' })
export class CardOnlineService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    findAll() {
        return this.http.get<CardOnline[]>(`${environment.apiEndpoint}/v1/card/online`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    isOnline(cardNumber: string) {
        return this.http.get<any>(`${environment.apiEndpoint}/v1/auth/card-login/is-online/` + cardNumber, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }),
        });
    }
}
